<p>
    Te hemos enviado un correo con las instrucciones para la confirmacion de tu cuenta. Si no lo vez haz clic
    <a (click)="requestConfirmarEmail()">acá</a>
    para volver a enviarlo o comunícate con nosotros.
</p>
<p *ngIf="instruccionesEnviadas" class="alert alert-success">
    Te hemos reenviado correctamente las instrucciones para validar tu cuenta.
</p>
